import { TopBar } from "./TopBar";
import { Col } from "./Flexbox";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useTheme } from "../scripts/functions/ThemeProvider";
import ScrollStyles from "./ScrollStyles"
const MainLayout = () => {
    const location = useLocation();
    const navigate = useNavigate()

    const {theme, toggleTheme, isDark} = useTheme();

    useEffect(() => {
        document.body.style.backgroundColor = theme.Alfalfa;
        document.body.style.transition = "background-color 0.3s ease";
    }, [theme]);

    return (
        <Col style={{height: '100vh', width: '100vw', minWidth: 0, overflowX: 'hidden', justifyContent: 'flex-start'}}>
            <ScrollStyles theme={theme}/>
            <TopBar key={isDark ? 'dark' : 'light'} path={location.pathname} navigate={navigate} theme={theme} toggleTheme={toggleTheme} isDark={isDark}/>
            <Outlet/>
        </Col>
    )
}

export default MainLayout;